import { render, staticRenderFns } from "./imageHandle.vue?vue&type=template&id=8da7081a&scoped=true&"
import script from "./imageHandle.vue?vue&type=script&lang=js&"
export * from "./imageHandle.vue?vue&type=script&lang=js&"
import style0 from "./imageHandle.vue?vue&type=style&index=0&id=8da7081a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da7081a",
  null
  
)

export default component.exports